import {getDate} from "../js/tool";

export const mealColumns = [
    {title: '酒店名称', dataIndex: 'hotel_name'},
    {title: '酒店地址', dataIndex: 'hotel_address'},
    {title: '用餐地点', dataIndex: 'dining_place'},
    {title: '用餐类型', dataIndex: 'dining_type'},
    {
        title: '用餐时间',
        dataIndex: 'dinner_start_time',
        width: 300,
        customRender: (text, record) => `${getDate(text).pattern("yyyy-MM-dd HH:mm")} 至 ${getDate(record.dinner_end_time).pattern("yyyy-MM-dd HH:mm")}`
    },
    {
        title: '早餐时间',
        dataIndex: 'breakfast_start_time',
        customRender: (text, record) => `${text}-${record.breakfast_end_time}`
    },
    {
        title: '午餐时间',
        dataIndex: 'lunch_start_time',
        customRender: (text, record) => `${text}-${record.lunch_end_time}`
    },
    {
        title: '晚餐时间',
        dataIndex: 'supper_start_time',
        customRender: (text, record) => `${text}-${record.supper_end_time}`
    },
]
